const style = {
    body: {
        display: 'flex',
        flexDirection: 'row',
        height: 'calc(100vh - 70px)',
    },
};

export default style;
